import { InputHTMLAttributes, ReactNode } from 'react';
import Form from 'react-bootstrap/Form';

import {
    AsyncTypeaheadInput,
    CheckboxRadioInput,
    CreatableSelectInput,
    DateInput,
    EditorInput,
    FileInput,
    GenericInput,
    GenericInputProps,
    InputType,
    MarginInput,
    MultiEmailInput,
    PasswordInput as PasswordInputType,
    SelectInput,
    TextareaInput,
    TextInput,
    TypeaheadInput,
    ZipInput as ZipInputType
} from './input.type';

import HyperTypeahead from 'components/HyperTypeahead';
import Div from 'components/Div';
import { InputGroup } from 'react-bootstrap';

type FormInputProps = InputHTMLAttributes<HTMLInputElement> &
    PasswordInputType &
    CheckboxRadioInput &
    DateInput &
    CreatableSelectInput &
    SelectInput &
    TypeaheadInput &
    AsyncTypeaheadInput &
    TextareaInput &
    EditorInput &
    ZipInputType &
    TextInput &
    FileInput &
    MultiEmailInput &
    MarginInput &
    GenericInput;
function FormInput2<T extends InputType>({
    type,
    ...props
}: { type: T } & GenericInputProps<T>);
function FormInput2({
    label,
    type,
    name,
    placeholder,
    register,
    validation,
    errors,
    control,
    inputClassName,
    labelClassName,
    containerClass,
    refCallback,
    options,
    disabled,
    multiple,
    labelKey,
    isLoading,
    onSearch,
    icon,
    value,
    checked,
    menuPlacement,
    minDate,
    maxDate,
    rows,
    onCreateOption,
    onlyMonthPicker,
    closeOnSelect,
    disabledDates,
    datesClassnames,
    enableSundays,
    handleEmails,
    clearable,
    tooltip,
    tooltipPlacement,
    prefix,
    sufix,
    ...otherProps
}: FormInputProps) {
    // handle input type
    const comp = type === 'checkbox' ? 'checkbox' : 'input';

    let input = <></>;

    

    switch (type) {
        case 'typeahead':
            input = (
                <Form.Group className={containerClass}>
                    {label ? (
                        <Form.Label className={labelClassName}>
                            {label}
                        </Form.Label>
                    ) : null}
                    <HyperTypeahead
                        options={options}
                        name={name}
                        control={control}
                        disabled={disabled}
                        multiple={multiple}
                        labelKey={labelKey}
                        placeholder={placeholder}
                        validation={validation}
                        isInvalid={errors && Boolean(errors[name])}
                    />
                    {errors && errors[name] ? (
                        <Form.Control.Feedback type="invalid">
                            {errors[name]['message'] as string}
                        </Form.Control.Feedback>
                    ) : null}
                </Form.Group>
            );
            break;
        case 'asyncTypeahead':
            input = (
                <Form.Group className={containerClass}>
                    {label ? (
                        <Form.Label className={labelClassName}>
                            {label}
                        </Form.Label>
                    ) : null}
                    <HyperTypeahead
                        options={options}
                        name={name}
                        control={control}
                        disabled={disabled}
                        multiple={multiple}
                        labelKey={labelKey}
                        placeholder={placeholder}
                        validation={validation}
                        isInvalid={errors && Boolean(errors[name])}
                        aSync={true}
                        isLoading={isLoading}
                        onSearch={onSearch}
                    />
                    {errors && errors[name] ? (
                        <Form.Control.Feedback type="invalid">
                            {errors[name]['message'] as string}
                        </Form.Control.Feedback>
                    ) : null}
                </Form.Group>
            );
            break;
        case 'checkbox':
        case 'radio':
        case 'switch':
            input = (
                <Form.Group className={containerClass}>
                    <Form.Check
                        type={type}
                        label={
                            <Div className="ps-1">
                                {icon} {label}
                            </Div>
                        }
                        name={name}
                        id={otherProps.id}
                        ref={(r: HTMLInputElement) => {
                            if (refCallback) {
                                refCallback(r);
                            }
                        }}
                        disabled={disabled}
                        value={value}
                        checked={checked}
                        className={`d-flex align-items-center ${inputClassName}`}
                        isInvalid={errors && Boolean(errors[name])}
                        {...(register
                            ? register(name, {
                                ...validation
                            })
                            : {})}
                        {...otherProps}
                    />

                    {errors && errors[name] ? (
                        <Form.Control.Feedback type="invalid">
                            {errors[name]['message'] as string}
                        </Form.Control.Feedback>
                    ) : null}
                </Form.Group>
            );
            break;
        default:
            input = (
                <Form.Group className={containerClass}>
                    {label ? (
                        <Form.Label className={labelClassName}>
                            {label}
                        </Form.Label>
                    ) : null}
                    <Form.Control
                        type={type}
                        placeholder={placeholder}
                        name={name}
                        id={name}
                        as={comp}
                        ref={(r: HTMLInputElement) => {
                            if (refCallback) {
                                refCallback(r);
                            }
                        }}
                        className={inputClassName}
                        isInvalid={errors && errors[name] ? true : false}
                        {...(register
                            ? register(name, {
                                ...validation
                            })
                            : {})}
                        {...otherProps}
                        autoComplete={name}
                        disabled={disabled}
                        onWheel={(e) => {
                            // Prevent the input value change
                            e.target?.['blur']();

                            // Prevent the page/container scrolling
                            e.stopPropagation();

                            // Refocus immediately, on the next tick (after the current     function is done)
                            setTimeout(() => {
                                e.target?.['focus']();
                            }, 0);
                        }}
                    />

                    {errors && errors[name] ? (
                        <Form.Control.Feedback type="invalid">
                            {errors[name]['message'] as string}
                        </Form.Control.Feedback>
                    ) : null}
                </Form.Group>
            );
    }

    
}

export default FormInput2;
